export default __webpack_public_path__ + "de8388dd88dca1136ec65ab5b42d5f9e.png";